import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '..';

const SearchPanelBrowserMobile = ({ ...props }) => {
  const { t } = useTranslation();
  const ref = useRef<HTMLElement>(null);

  return (
    <>
      <main className="search-panel-browser-container" {...props}>
        <section className="search-panel-box" ref={ref}>
          <button className="search-panel-main-content" type="button">
            <article className="search-panel-main-content-label-wrapper">
              <span className="search-panel-main-content-label">{t('home.searchPanel.mobile.label')}</span>
            </article>

            <article className="search-panel-main-content-icon-wrapper">
              <Icon className="search-panel-main-content-search-icon" icon="search" round />
            </article>
          </button>
        </section>
      </main>
    </>
  );
};

export default SearchPanelBrowserMobile;
